import { render, staticRenderFns } from "./relatorios.vue?vue&type=template&id=ac951fd2&scoped=true&"
import script from "./relatorios.vue?vue&type=script&lang=js&"
export * from "./relatorios.vue?vue&type=script&lang=js&"
import style0 from "./relatorios.vue?vue&type=style&index=0&id=ac951fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac951fd2",
  null
  
)

export default component.exports